// BdePerformanceItem.tsx

import React from 'react';
import { BdePerformanceEntry, PerformanceAlertType } from './config';
import { AlertOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Avatar } from 'antd'; 
// NOTE: Ensure your Tailwind CSS configuration is active.

interface BdePerformanceItemProps {
  data: BdePerformanceEntry;
}

const getAlertIcon = (type: PerformanceAlertType) => {
  // Use 'text-base' or 'text-lg' to match text size. 
  // 'inline-block' helps treat the icon like text for alignment.
  const iconClasses = 'text-lg align-middle inline-block'; 

  switch (type) {
    case 'danger':
      // Using 'text-red-500' for color
      return <ExclamationCircleOutlined className={`${iconClasses} text-red-500`} />;
    case 'warning':
      // Using 'text-yellow-500' for color
      return <AlertOutlined className={`${iconClasses} text-yellow-500`} />;
    case 'success':
      // Using 'text-green-500' for color
      return <CheckCircleOutlined className={`${iconClasses} text-green-500`} />;
    default:
      return null;
  }
};

export const BdePerformanceItem: React.FC<BdePerformanceItemProps> = ({ data }) => {
  const icon = getAlertIcon(data.alert.type);
  const message = data.alert.message;

  // Logic to handle the '!' for the danger case, as seen in the design
  const displayMessage = data.alert.type === 'danger' ? `! ${message}` : message;

  return (
    <div className="flex items-center p-4 border-b border-gray-100 last:border-b-0 bg-white">
      
      {/* 1. Employee Info (Left Side) */}
      <Avatar 
        size="large" 
        src={data.employee.avatarUrl} 
        alt={data.employee.name} 
        className="mr-3 flex-shrink-0" // Added flex-shrink-0 to prevent avatar shrinking
      />
      <div className=" mr-4"> {/* Added min-w-0 for better flex behavior */}
        <p className="text-sm font-semibold text-gray-800">{data.employee.name}</p>
        <p className="text-xs text-gray-500">{data.employee.id}</p>
      </div>

     
      <div className="flex items-center justify-center ml-6">
        
       
        <span className="flex-shrink-0">{icon}</span>
        
        {/* Text Message - The 'ml-2' provides the exact spacing shown */}
        <span className="ml-2 text-sm text-gray-600 whitespace-nowrap">
          {displayMessage}
        </span>
      </div>
    </div>
  );
};